import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Input from "../ui/Input";
import Button from "../ui/Button";

const LoginForm = ({ onLogin }) => {
  console.log('LoginForm rendered');
  const navigate = useNavigate();
  const [user, setUser] = useState({ username: "", password: "" });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleChange = (e) => {
    console.log("LoginForm - handleChange:", e.target.name, e.target.value);
    setUser({ ...user, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    
    console.log("LoginForm - user data:", user);
    console.log("LoginForm - username:", user.username);
    console.log("LoginForm - password:", user.password);
    
    try {
      // Вызываем onLogin с данными пользователя
      if (onLogin) {
        await onLogin(user.username, user.password);
      }
    } catch (err) {
      console.error("LoginForm - error:", err);
      console.error("LoginForm - error response:", err.response);
      setError("Ошибка входа. Проверьте email и пароль.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-200">
      <form onSubmit={handleSubmit} className="bg-white p-8 rounded-lg shadow-md w-96 space-y-4">
        <div className="text-center">
          <h2 className="text-2xl font-bold text-gray-900 mb-2">Вход в систему</h2>
          <p className="text-gray-600">Введите свои учетные данные</p>
        </div>
        <Input
          label="Email"
          name="username"
          type="email"
          value={user.username}
          onChange={handleChange}
          autoComplete="email"
        />
        <Input
          label="Пароль"
          name="password"
          type="password"
          value={user.password}
          onChange={handleChange}
          autoComplete="current-password"
        />
        {error && <div className="text-red-500 text-sm text-center">{error}</div>}
        <Button type="submit" disabled={loading} className="w-full">
          {loading ? "Вход..." : "Войти"}
        </Button>
        
        <div className="text-center mt-4">
          <button
            type="button"
            onClick={() => navigate('/register')}
            className="text-blue-600 hover:text-blue-800 text-sm underline"
          >
            Нет аккаунта? Зарегистрироваться
          </button>
        </div>
      </form>
    </div>
  );
};

export default LoginForm; 